<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref } from 'vue'
  import ButtonDefault from '@/elements/ButtonDefault.vue'

  const visible = ref(false)
  const threshold = 120

  function onScroll() {
    visible.value = window.scrollY > threshold
  }

  onMounted(() => {
    window.addEventListener('scroll', onScroll, { passive: true })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)
  })

  const onShowMenuClick = () => {
    useEventBus('showMobileMenuClick').emit()
  }
</script>

<template>
  <Transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0 translate-y-4"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-150 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-4">
    <div
      v-if="visible"
      class="fixed bottom-20 right-5 z-50 md:hidden pointer-events-auto">
      <ButtonDefault
        rounded
        icon="MenuOpenIcon"
        class="shadow-xl"
      @click="onShowMenuClick"/>
    </div>
  </Transition>
</template>
